import * as yup from 'yup'
import {
    flatten,
    cloneDeep,
    intersection,
    isEmpty,
    isMatch,
    isNull,
    isUndefined,
    keys,
    omit,
} from 'lodash'
import { GeneralAPI } from '../apis/GeneralAPI'
import {
    _getImpersonatedByEmail,
    _isImpersonated,
    convertBase64ToFiles,
    convertSmartySteetValidJsonToFiles,
    convertToArrayToLines,
    convertToInteger,
    fbTrackAddToCart,
    formatPrice,
    log,
    log2,
} from './utils'
import { has } from 'lodash'
import { getAddOnToAddToCart } from '../state/AddOnProductStore'
// import { CartStore } from '../state/CartStore'
import { nanoid } from 'nanoid'
import { nextAPI } from '../apis/Axios'
import {
    _BATCH_PRICE_KEY,
    findMetaDataByKey,
    // _DISCOUNTED_TOTAL_KEY,
} from './checkout'
import { isObject } from 'lodash'
import { FileAPI } from '../apis/FileAPI'
import { CartAPI } from '../apis/CartAPI'
import SelectDesignModal from '../components/Modals/SelectDesignModal'
import SelectTemplateModal from '../components/Modals/SelectTemplateModal'
import { UserStore } from '../state/UserStore'
import { CustomerAPI, OrdersFetcher } from '../apis/CustomerAPI'
import { ExternalLinkIcon } from '@heroicons/react/outline'
import { getFirstValidProductFromOrder, validProofProducts } from './proofs'

// import { getCurrentCustomer } from '../apis/CustomerAPI'

export const TOTLAMAILERS_METAKEY = 'Total Mailers'
export const MAILERS_QUANTITY_METAKEY = 'Mailers Quantity'
export const ACTUAL_QUANTITY_METAKEY = 'Actual Quantity'

/**
 * the image mb validation was removed when doing showExtraField
 */

export const logoField = {
    label: 'Select Design Files',
    // isAttribute: true,
    name: 'Logo',
    allowed_types: 'image',
    type: 'choose-modal',
    maxFiles: 50,
    modal: SelectDesignModal,
    required: true,
    description:
        'Upload new files or pick from your saved library — logos, headshots, designs, copy. Uploads are saved to your account so you can reuse them next time.',
    message: 'Please Select a Design File',
    error: {
        required: 'Please Select a Design File',
        maxFiles: 'You can only upload 50 files',
    },
}

export const undelivarblesField = {
    type: 'toggle',
    name: 'Receive your undeliverable leads?',
    label: 'Receive your undeliverable leads?',
    description:
        '$19 additional fee. Undeliverable leads will be emailed to you after placing your order.',
    priceLabel: '+$19',
    toggleVariant: 'compact',
    value: true,
    required: false,
}

export const returnMailAddOnField = {
    type: 'toggle',
    name: 'Receive Returned Mail List?',
    label: 'Receive Returned Mail List?',
    description:
        '$35 additional fee. A list of your returned mail will be emailed to you 14 days after your mailed date',
    priceLabel: '+$35',
    toggleVariant: 'compact',
    value: true,
    required: false,
}

// export const AddOfferField = {
//     type: 'toggle',
//     name: 'Add Offer?',
//     label: 'Add Offer?',
//     description: '$0.06 additional fee per record.',
//     value: true,
//     required: false,
// }

export const AddOfferField = {
    name: 'Add Offer?',
    label: 'Add Offer?',
    description: '$0.06 additional fee per record.',
    required: true,
    type: 'select',
    toggleVariant: 'upgrade',
    tagLabel: 'Real estate',
    tooltipText:
        "Print a cash offer on each letter, calculated from the property's value.",
    optionsLabel: 'Offer values',
    noteText:
        "You'll set the exact offer amounts on the next step, after your mailing list is uploaded.",
    options: [
        "No, don't add offer",
        'Yes, use OLM’s offer values (+$0.06)',
        'Yes, use my offer values',
    ],
    paidOption: ['Yes, use OLM’s offer values (+$0.06)', 'Reupload-Offer'],
    default: 'Yes, use OLM’s offer values (+$0.06)',
    defaultCondition: {
        type: 'product',
        value: ['ros-letters', 'snap-pack-check-mailers-ros'],
    },
}

export const pagesAndPrintingField = {
    name: 'Pages & Printing',
    label: 'Pages & Printing',
    type: 'select',
    required: false,
    options: [
        '1 page, single-sided',
        '1 page, double-sided (+$0.06 / piece)',
        '2 pages, single-sided (+$0.12 / piece)',
        '2 pages, double-sided (+$0.18 / piece)',
    ],
    default: '1 page, single-sided',
    defaultValue: '1 page, single-sided',
}

export const upgradesSectionField = {
    name: 'Upgrades Section',
    type: 'section-label',
    label: 'Upgrades',
}

export const appearanceSectionField = {
    name: 'Appearance Section',
    type: 'appearance-section',
    label: 'Appearance',
    tooltipText:
        "These are OLM's recommended defaults for this template — change any of them.",
}

export const streetviewImageField = {
    name: 'Add Streetview Image',
    label: 'Add Streetview Image',
    type: 'select',
    options: ['No', 'Yes (+$0.02)'],
    description:
        'Prints a Streetview image of each property address on the mailer.',
    priceLabel: '+$0.02/pc',
    toggleVariant: 'upgrade',
    required: false,
}

export const shippingField = {
    type: 'hidden',
    name: 'Shipping Fee',
    label: 'Shipping Fee',
    value: 1,
    required: false,
}

export const professionalShippingField = {
    type: 'hidden',
    name: 'Professional Shipping Fee',
    label: 'Professional Shipping Fee',
    value: 1,
    required: false,
}

export const noOfRecordsField = {
    type: 'text',
    specificType: 'number',
    label: 'Number of records to be mailed',
    name: 'noOfRecordsField',
    required: true,
    visibility: 'visible',
    placeholder: 'e.g. 1,500',
    description:
        "Tell us how many you want to reach and we'll contact you to build your mailing list.",
    message: 'Please enter No of Records to be mailed.',
}

export const purchaseField = {
    type: 'checkbox',
    label: 'Have OLM build a custom list',
    name: 'Purchase a List',
    required: false,
    visibility: 'visible',
    minQuantity: 500,
    description:
        "We'll call within 24 business hours to discuss your criteria.",
}

export const hasSetNoOfRecordsManually = (data) => {
    return (
        !isEmpty(data[noOfRecordsField.name]) && isEmpty(data[leadField.name])
    )
}

export const handleManuallySetNoOfRecords = (data, quanityBeforeMultiplier) => {
    if (data[purchaseField.name] == true) {
        data[purchaseField.name] =
            data[noOfRecordsField.name] < purchaseField.minQuantity
                ? purchaseField.minQuantity
                : quanityBeforeMultiplier
    } else {
        delete data[purchaseField.name]
    }
    delete data[leadField.name]
    delete data['files']
    return data
}

export const getNoOf = (data) => !isEmpty(data[noOfRecordsField.name])

export const getshippingFieldObject = ({ slug }) => {
    return String(slug).toLowerCase().includes('professional')
        ? professionalShippingField
        : shippingField
}
export const getshippingFieldName = ({ slug }) => {
    return getshippingFieldObject({ slug }).name
}

export const getNoOfShippingFee = (quantity) => {
    let noOfShippingFee = convertToInteger(Math.ceil(quantity / 500))
    if (noOfShippingFee < 1) noOfShippingFee = 1
    return noOfShippingFee
}

export const getShippingField = ({ quantity, product }) => {
    const noOfShippingFee = getNoOfShippingFee(quantity)
    const shippingProduct = getshippingFieldObject(product)

    return {
        ...shippingProduct,
        value: noOfShippingFee,
        defaultValue: noOfShippingFee,
    }
}

export const shippingProducts = [
    'real-penned-letters',
    'real-penned-professional-letters',
]

export const shouldAddShipping = (slug) => {
    return shippingProducts.includes(slug)
}

export const shippingProductsNames = [
    'real penned personal letters',
    'real penned professional letters',
]

export const shouldAddShippingCampaignProduct = (name) => {
    return shippingProductsNames.includes(name)
}

export const deliverableNamePrefix = 'Deliverable-'
export const undeliverableNamePrefix = 'UnDeliverable-'

export const isCsvFilesField = (key) => key === 'files' // check CSVStore
export const isLeadFiles = (key) =>
    key === MappedFieldName || key === LeadFieldName
export const MappedFieldName = `${deliverableNamePrefix}Files`
export const LeadFieldName = 'Original-Files'

export const leadField = {
    type: 'leadupload',
    label: 'Mailing list (CSV)',
    name: LeadFieldName,
    required: true,
    allowed_types: 'csv',
    visibility: 'visible',
}

export const customerListFieldName = 'Customer-List'
export const customerHasListOptionValue = 'yes'
export const customerHasNoListOptionValue = 'no'

export const leadFields = [leadField]

export const customerListName = 'customer-list'

export const stepTwoAddonFields = [undelivarblesField, returnMailAddOnField]

export const nonListFields = [
    noOfRecordsField,
    purchaseField,
    ...stepTwoAddonFields,
]

export const mappingListOptions = [
    {
        id: '1',
        name: customerListName,
        label: 'Upload your List',
        value: customerHasListOptionValue,
        items: [leadField, ...stepTwoAddonFields],
    },
    {
        id: '2',
        name: customerListName,
        label: 'I don’t have a list right now',
        value: customerHasNoListOptionValue,
        items: nonListFields,
    },
]

export const mappingListGroupField = {
    name: 'Mapping List Group',
    type: 'mapping-list-group',
    label: 'Mapping List Group',
    required: true,
    options: mappingListOptions,
    error: {
        required: 'Please Select an Option for List.',
    },
    message: 'Please Select an Option for List.',
}

export const checkTOSField = {
    type: 'checkbox',
    label: `Click here to accept the<a
        className="ml-1 underline hover:no-underline"
        target="_blank"
        href="/terms"
        rel="noreferrer">
        terms of service
    </a>
    .`,
    name: 'toc',
    required: true,
}

export const batchOptions = [
    {
        label: 'Batch Mailing',
        required: true,
        name: 'Batch Mailing',
        type: 'select',
        options: ['Mail All at Once'],
    },
    {
        label: 'Time Between Each Touch',
        required: true,
        name: 'Time Between Each Touch',
        type: 'select',
        options: [
            'Week',
            'Two Weeks',
            'Three Weeks',
            'Four Weeks',
            'Five Weeks',
            'Six Weeks',
            'Seven Weeks',
            'Eight Weeks',
        ],
        include: [
            'proven-mix-campaigns',
            'create-your-own-campaign',
            'pro180-campaigns',
        ],
    },
    {
        label: 'Est. Mailing Date',
        required: true,
        name: 'Mailing Date',
        type: 'date',
        exclude: ['real-penned-letters'],
    },
]

export const isPostcardProduct = ({ slug }) => String(slug) === 'postcards'
export const isJoeHomeBuyerProduct = ({ slug }) => String(slug).includes('jhb')

export const isRealPennedPostcardProduct = ({ slug }) =>
    String(slug).includes('real-penned-postcards')

export const isRealPennedProductByName = (name) =>
    String(name).toLowerCase().includes('real penned')

export const isRealPennedProduct = ({ slug }) =>
    String(slug).includes('real-penned') &&
    !isRealPennedPostcardProduct({ slug })

export const isPersonalLetterProduct = ({ slug }) =>
    String(slug) === 'personal-letters'

export const isProfessionalLetterProduct = ({ slug }) =>
    String(slug) === 'professional-letters'

export const isRealPennedLetterProduct = ({ slug }) =>
    String(slug) === 'real-penned-letters'

export const isRealPennedProfessionalLetterProduct = ({ slug }) =>
    String(slug) === 'real-penned-professional-letters'

export const shouldAddPagesAndPrinting = ({ slug }) =>
    isPersonalLetterProduct({ slug }) ||
    isProfessionalLetterProduct({ slug }) ||
    isRealPennedLetterProduct({ slug }) ||
    isRealPennedProfessionalLetterProduct({ slug })

const getPerBatchQuantity = (product) => {
    /**
     * @TODO Campaign Batching
     */

    // let hasPostCard = false

    // Letters/tri-folds/RP Postcards - 200
    // Postcards - 500
    // RP Letters - 100
    // All campaigns Proven mix and CYO - 500

    if (isCYOProduct(product) || isProvenMixProduct(product)) {
        return 500
    } else if (
        isPostcardProduct(product) &&
        !isRealPennedPostcardProduct(product)
    ) {
        return 500
    } else if (isRealPennedProduct(product)) {
        return 100
    } else {
        return 200
    }

    // if (isMultiTouchProduct(product)) {
    //     const values = getValues()
    //     // this is create your own campaign
    //     const touches = getCampaingTouches(values)
    //     const touchesArray = Array(touches)
    //         .fill('')
    //         .map((value, idx) => `Mailer Type ${idx + 1}`)
    //     const mailerTypes = touchesArray.map((value) => values[value])
    //     hasPostCard = mailerTypes.some((value) =>
    //         String(value).toLowerCase().includes('postcard'),
    //     )
    // }

    // if (isProvenMixProduct(product)) {
    //     const values = getValues()
    //     const touches = getCampaingTouches(values)
    //     // @note check olm-plugin/ControlSheet.php
    //     hasPostCard = touches === 4 ? false : true
    // }

    // let perBatch =
    //     isPostcardProduct(product) ||
    //     isJoeHomeBuyerProduct(product) ||
    //     hasPostCard
    //         ? 500
    //         : 200
    // return isRealPennedPostcardProduct(product) ? 200 : perBatch
}

const getBatches = (quantity, product, getValues) => {
    let perBatchQuantity = getPerBatchQuantity(product, getValues)

    let batches = Math.floor(quantity / perBatchQuantity)
    const options = []
    if (batches > 1) {
        for (let index = 1; index < batches; index++) {
            options.push(`${index + 1}`)
            if (index === 7) break // max 8 batches
        }
    }
    return options
}

export const getBatchOptions = (quantity, product, getValues) => {
    let mailingOptions = {
        ...batchOptions[0],
        options: [...batchOptions[0].options],
    } // first option is the batch mailing
    const suffix = 'Batches'
    let options = [mailingOptions.options[0]]
    const batches = getBatches(quantity, product, getValues)
    if (batches.length > 0) {
        batches.forEach((batch) => {
            options.push(`${batch} ${suffix}`)
        })
    }
    mailingOptions.options = options
    const leftOvers = batchOptions.slice(1)

    const fiteredLeftOvers = leftOvers.filter((item) => {
        return (
            !shouldNotIncludeField(item, product) ||
            shouldIncludeField(item, product)
        )
    })

    return [mailingOptions, ...fiteredLeftOvers]
}

export const shouldNotIncludeField = (item, product) => {
    return product && item?.exclude?.includes(product.slug)
}

export const shouldIncludeField = (item, product) => {
    return !has(item, 'include')
        ? true
        : product && item?.include?.includes(product.slug)
}

const hiddenMultiTouchFields = ['Letters', 'Flyers', 'Postcards']

const removeExtraMultiTouchFields = (fields) => {
    return fields.filter(
        (field) => !hiddenMultiTouchFields.includes(field.name),
    )
}

export const fileSchema = yup.object().shape({
    image: yup
        .mixed()
        .required('You need to provide a file')
        .test('fileSize', 'The file is too large', (value) => {
            return value && value[0].size < 1024 * 1024 // 1MB
        }),
})

export const imageValidate = async (value) => {
    return await fileSchema.isValid({
        image: value,
    })
}

/**
 * @TODO should delete it ? we don't have any place where this can be downloaded ?
 */
export function downloadFile() {
    // id
    // const file = Csvfiles.find((item, idx) => idx === id)
    // if (file) CSV.createFile(file.data.valids)
}

/**
 * @TODO file array when blank does not produce error
 */
export const getValidation = ({ type, message, error }) => {
    return type === 'text'
        ? yup.string().required(message)
        : type === 'textarea'
        ? yup.string().required()
        : type === 'leadupload'
        ? yup
              .array()
              .of(yup.mixed().required())
              .required('You need to provide at least a file.')
        : type === 'fileupload'
        ? yup
              .array()
              .of(yup.mixed())
              .required('You need to provide at least a file.')
        : type === 'checkbox'
        ? yup.bool().oneOf([true], 'Please accept the terms and conditions.')
        : type === 'choose-modal'
        ? yup.mixed().required(error.required)
        : yup.mixed().required(message)
}

export const defaultCustomizationTemplateFieldName =
    'defaultCustomizationTemplate'

export const conditionalMandatoryAfterNewOrderProcess = (field, values) => {
    let required = field?.required

    const conditions = {
        [leadField.name]: {
            fieldToMatch: customerListFieldName,
            valueToMatch: customerHasNoListOptionValue,
            required: false,
        },
        [logoField.name]: {
            fieldToMatch: selectTemplateField.name,
            valueToMatch: chooseFromGalleryOptionName,
            required: false,
        },
        [rosField.name]: {
            fieldToMatch: mappingListGroupField.name,
            valueToMatch: customerHasNoListOptionValue,
            required: false,
        },
    }

    if (has(conditions, field.name)) {
        const condition = conditions[field.name]
        if (
            has(values, condition.fieldToMatch) &&
            values[condition.fieldToMatch] == condition.valueToMatch
        ) {
            required = condition.required
        }
    }

    return { ...field, required }
}

export const conditionalMandatoryAfterNewOrderProcessBasedOnProduct = (
    field,
    product,
) => {
    let required = field?.required

    const _isProvenMix = isProvenMixProduct(product)

    const conditions = {
        [logoField.name]: {
            required: !_isProvenMix,
        },
    }

    if (has(conditions, field.name)) {
        const condition = conditions[field.name]
        if (condition) {
            required = condition.required
        }
    }

    return { ...field, required }
}

export const getMappingitemOptions = (itemsOptions, urlProduct) => {
    const slug = urlProduct?.slug || ''
    if (slug.includes('ros') && slug !== 'snap-pack-check-mailers-ros') {
        return itemsOptions.filter((item) => item.name !== AddOfferField.name)
    }
    return itemsOptions
}

const maybeAddMappingListGroup = (fields, values, currentStep, product) => {
    if (currentStep < 2) return fields

    const mappingList = values[mappingListGroupField.name]

    if (!mappingList) return fields

    const getFields = mappingListGroupField.options.find(
        (option) => option.value == mappingList,
    )

    //console.log('maybeAddMappingListGroup fields', product, fields)

    if (getFields) {
        //console.log('getFields.items', getFields.items)

        const _getFields = getMappingitemOptions(getFields.items, product)
        //console.log('_getFields', _getFields)

        return [...fields, ...(Array.isArray(_getFields) ? _getFields : [])]
    }

    return fields
}

const isSelectDesignField = (field) => {
    return field?.name?.includes(logoField.name)
}

export const singleProductRules = ({
    values,
    currentStep = 1,
    stepsAndFields,
    multiTouchProducts,
    product,
    isThisMultiTouchProduct,
    slug,
}) => {
    /*
     * @TODO
     * can we do this validations using register method ? we know what all fields are registered and validate them ?
     * @TOFIX Validation still check when on lesser step
     */

    // log('values', values)

    const mailerKey = values[mailerKeyName]
    const mailerProduct = values?.[mailerProductName] || product

    const isCYO = isCYOProduct(product)
    const cyoContexts = {}
    let rulesObject = {}
    // Only have fields which are up to this step
    let fieldToValidate = flatten(
        stepsAndFields.slice(0, currentStep).map((field) => field.fields),
    )

    if (
        !isCYO ||
        fieldToValidate.some(
            (field) => field.name === mappingListGroupField.name,
        )
    ) {
        fieldToValidate = maybeAddMappingListGroup(
            fieldToValidate,
            values,
            currentStep,
            product,
        )
    }

    // if (isRosProduct(slug) && currentStep === 2) {
    //     if (rosField.required) {
    //         fieldToValidate.push({ ...rosField })
    //     }
    // }

    const isMailingListStep =
        stepsAndFields?.[currentStep - 1]?.name === 'Your mailing list'

    // snap-pack-check-mailers-ros is an exception - it should only require ROS Offer based on user selection
    const isSnapPackRos = product.slug === 'snap-pack-check-mailers-ros'
    const shouldRequireRosOffer = isCYO
        ? shouldChooseCYOOffer(values)
        : isSnapPackRos
        ? GetAddOfferValueFromGetValues(values) // Only when paid option is selected
        : GetAddOfferValueFromGetValues(values) || isRosProduct(product.slug) // Other ROS products always require it

    if (shouldRequireRosOffer && isMailingListStep) {
        if (rosField.required) {
            fieldToValidate.push({ ...rosField })
        }
    }

    // log('stepsAndFields', stepsAndFields)
    // log('fieldToValidate', values, fieldToValidate)

    // isNullFieldType({ item, product, attributes, values, mailerKey, defaultCustomizationTemplate, ...props })

    // if (isNullFieldType({ item, product, attributes, values, mailerKey, ...props })) {

    /** this is MultiTouch Products Validations */
    // We will first check at this point what all mailers are available,
    // based on those value we will validate the fields which are showing right now
    // Lets get all values which are showing right now

    const activeMailerKeys = new Set(
        fieldToValidate
            .filter((field) => /^Mailer Type \d+$/.test(field.name))
            .map((field) => field.name),
    )
    for (const [key, value] of Object.entries(values)) {
        if (isCYO && !activeMailerKeys.has(key)) continue
        // log(key, isMultiTouchFieldBase(key) && value)
        if (isMultiTouchFieldBase(key) && value) {
            let fields = isCYO
                ? getCYOFields(multiTouchProducts, value, key)
                : getMultiTouchFields(multiTouchProducts, value, key)
            if (isCYO) {
                cyoContexts[key] = {
                    mailerKey: key,
                    product:
                        multiTouchProducts.find((item) => item.name === value)
                            ?.product || product,
                    attributes: fields,
                }
                for (const conditional of conditionalFields) {
                    const fieldName = makeFieldMultiTouch(conditional.name, key)
                    if (
                        conditional.when.includes(values[fieldName]) &&
                        conditional.item.required
                    ) {
                        fieldToValidate.push({
                            ...conditional.item,
                            name: makeFieldMultiTouch(
                                conditional.item.name,
                                key,
                            ),
                            mailerKey: key,
                        })
                    }
                }
            }
            let selectedTemplate =
                values[makeFieldMultiTouch(selectTemplateField.name, key)]
            let isDesignMyFileSelected =
                selectedTemplate === designMyFileFieldName
            for (const field of fields) {
                if (field.required) {
                    if (!isSelectDesignField(field) || isDesignMyFileSelected) {
                        fieldToValidate.push({ ...field })
                    }
                    // if(field.name.includes('Select/type the order')){
                    //     log('showField Validation',field)
                    // }

                    // const isFieldNull = isNullFieldType({
                    //     item: field,
                    //     product: mailerProduct,
                    //     values,
                    //     attributes: values[AttributesFieldName],
                    //     mailerKey,
                    //     isValidating: true,
                    // })

                    // if(!isFieldNull) {
                    //     rulesObject[field.name] = getValidation(field.type)
                    // }
                }
            }
        }
    }

    // console.log('conditionalFields', conditionalFields)

    /** We now check if there is any additional conditinal fields based on attrs */
    /** @TODO, can this logic be better ? e.g include product ? */
    log('from validation values', values)
    for (const [key, value] of Object.entries(values)) {
        if (key.includes('Select Template')) {
            // log('values Select Template validation', key, value, values)
        }
        for (const field of conditionalFields) {
            // if(field.item.label.includes('Select/type the order')){
            //     log('showField Validation',
            //     field, '|' ,key, '|', mailerKey, '|', value, '|',
            //     makeFieldMultiTouch(field.name, mailerKey))
            // }
            if (
                (!isCYO || !key.startsWith('Mailer Type ')) &&
                makeFieldMultiTouch(
                    field.name,
                    isCYO ? undefined : mailerKey,
                ) === key &&
                field.when.includes(value) &&
                field.item.required
            ) {
                let modifyName = { ...field.item }
                modifyName.name = makeFieldMultiTouch(
                    field.item.name,
                    mailerKey,
                )
                fieldToValidate.push({ ...modifyName })
                // rulesObject[makeFieldMultiTouch(field.item.name, mailerKey)] = getValidation(field.item.type)
            }
        }
    }

    // log('fieldToValidate - == -', fieldToValidate)

    // we have a bug where in multiTouch products
    // it gives error for required fields from previous steps
    // we can simply remove those fields.
    /*
     We have an array fieldToValidate. we have some fields name such
     Mailer Type 1 Select Template, Mailer Type 2 Logo.
     Now if mailerkey is Mailer Type 3 then we need to remove all fields which are before Mailer Type 3
     meaning which has prefix Mailer Type 1, Mailer Type 2. write a js function
    */

    function removePreviousMailerTypes(fieldToValidate, mailerKey) {
        if (!mailerKey) return fieldToValidate

        // extract the mailer type number from the mailerKey
        let mailerTypeNumber = parseInt(mailerKey.split(' ')[2])

        return fieldToValidate.filter((field) => {
            // split each field name into parts
            let fieldParts = field.name.split(' ')

            // if the first part is not "Mailer" or there's no type number, keep the field
            if (fieldParts[0] !== 'Mailer' || isNaN(fieldParts[2])) {
                return true
            }

            // get the mailer type number of the current field
            let fieldTypeNumber = parseInt(fieldParts[2])

            // only keep the field if its type number is greater or equal to the mailer type number of the mailerKey
            return fieldTypeNumber >= mailerTypeNumber
        })
    }

    if (isThisMultiTouchProduct && !isCYO) {
        fieldToValidate = removePreviousMailerTypes(fieldToValidate, mailerKey)
    }

    for (let field of fieldToValidate) {
        const key = field.name.match(/^(Mailer Type \d+)(?: |$)/)?.[1]
        const context = isCYO
            ? cyoContexts[key] || { product, attributes: product.attributes }
            : {
                  product: mailerProduct,
                  attributes: values[AttributesFieldName],
                  mailerKey,
              }
        if (
            isNullFieldType({
                item: field,
                ...context,
                values,
                isValidating: true,
            })
        ) {
            continue
        }

        // this modfiy required field based on some conditions
        field = conditionalMandatoryAfterNewOrderProcessBasedOnProduct(
            field,
            product,
        )
        field = conditionalMandatoryAfterNewOrderProcess(field, values)

        if (field.required && shouldIncludeField(field, { slug })) {
            rulesObject[field.name] = getValidation(field)
        }
    }

    log('rulesObject', rulesObject)

    return yup.object().shape(rulesObject)
}

export const templateField = {
    label: 'Template',
    name: 'Template',
    required: true,
    type: 'choose-modal',
    modal: SelectTemplateModal,
    message: 'Please select a template',
    error: {
        required: 'Please select a template',
    },
}

const isMailerTypeMetaKey = (key) => /^Mailer Type \d+$/.test(String(key || ''))

const orderHasLineItemNameContaining = (order, needleLower) => {
    const items = validProofProducts(order?.line_items || [])
    return items.some((item) => {
        const hay = `${item.name || ''} ${item.parent_name || ''}`.toLowerCase()
        if (hay.includes(needleLower)) return true

        const meta = Array.isArray(item.meta_data) ? item.meta_data : []
        return meta.some(
            (m) =>
                isMailerTypeMetaKey(m?.key) &&
                String(m?.value || '')
                    .toLowerCase()
                    .includes(needleLower),
        )
    })
}

const fetchLoggedInCustomerOrders = async (ctx = {}) => {
    const user = await UserStore.getState().user

    if (!user.customer) return []

    const selectedProductName = String(ctx?.product?.name || '').trim()
    const selectedSlug = String(ctx?.product?.slug || '').toLowerCase()

    if (selectedSlug.includes('postcard')) {
        try {
            return await asyncUpdateCustomerOrders({
                lineItemNameContains: 'postcard',
                persistToUserStore: false,
            })
        } catch (e) {
            log(e)
            return []
        }
    }

    if (selectedProductName) {
        try {
            return await asyncUpdateCustomerOrders({
                lineItemNameContains: selectedProductName,
                persistToUserStore: false,
            })
        } catch (e) {
            log(e)
            return []
        }
    }

    const orders = user.orders

    log('customer', user?.orders)

    try {
        if (orders && orders.length > 0) {
            asyncUpdateCustomerOrders()
            log('fetchLoggedInCustomerOrders log')
            return orders
        } else {
            const fetched = await asyncUpdateCustomerOrders()
            return fetched
        }
    } catch (e) {
        log(e)
        return []
    }
}

export const asyncUpdateCustomerOrders = async (options = {}) => {
    const lineItemNameContains = options.lineItemNameContains
    const persistToUserStore = options.persistToUserStore !== false

    // we will fetch 500 orders, in hope that will do.
    let originalOrders = []
    const keys = [1, 2, 3, 4, 5]
    let totalKeys = 1

    for (const key of keys) {
        if (key > totalKeys) break
        const { data, headers } = await OrdersFetcher(
            `${CustomerAPI.getOrdersByCustomer}&page=${key}&perPage=100`,
        )
        totalKeys = headers['x-wp-totalpages']
        originalOrders.push(...data)
    }

    if (lineItemNameContains) {
        const needle = String(lineItemNameContains).toLowerCase()
        originalOrders = originalOrders.filter((order) =>
            orderHasLineItemNameContaining(order, needle),
        )
    }

    const orders = originalOrders.map((order) => {
        const validProduct = getFirstValidProductFromOrder(order)
        const productName = validProduct
            ? validProduct.name
            : 'No Valid Product'
        const variationId = validProduct?.variation_id || 0
        const pidSegment = !variationId
            ? ` - [pid:${validProduct?.product_id || 0}]`
            : ''
        return `#${order.id} ${order?.billing?.first_name} ${order?.billing?.last_name} - [${productName}] - [${variationId}]${pidSegment}`
    })

    if (persistToUserStore) {
        const updateOrders = UserStore.getState().updateOrders
        await updateOrders(orders)
    }

    return orders
}

export const customizeMailPieceField = {
    label: 'Customize your mail piece?',
    name: 'Customize Mail Piece',
    required: true,
    type: 'toggle',
    value: false,
    default: false, // Explicitly set default
    helperText: {
        false: "OLM's recommended options!",
        true: '',
    },
}

export const designMyFileFieldName = 'Design My File (upload required) +$99'
export const previsoulyDesignedFileFieldName = 'Previously Designed File'
export const selectPreviouslyDesignedFileFieldName =
    'Select a ' + previsoulyDesignedFileFieldName

export const chooseFromGalleryOptionName = 'Choose Template from Gallery'

export const editMessageFieldName = 'Edit Message'

export const orderNoForDesignFieldName = 'Order No For Design'
export const duplicatePreviousOrderFieldName = 'Duplicate this order'

export const selectTemplateField = {
    label: 'Select Template',
    name: 'Select Template',
    isAttribute: false,
    required: true,
    type: 'select',
    options: [
        {
            value: chooseFromGalleryOptionName,
            icon: ExternalLinkIcon,
        },
        selectPreviouslyDesignedFileFieldName,
        designMyFileFieldName,
    ],
    message: 'Please select a template',
    error: {
        required: 'Please select a template',
    },
}

const conditionalFields = [
    {
        name: 'Select Template',
        when: [chooseFromGalleryOptionName],
        item: {
            label: 'Select Template',
            name: 'Template',
            parent_field: 'Select Template',
            required: true,
            type: 'open-modal',
            modal: SelectTemplateModal,
            message: 'Please select a template',
            error: {
                required: 'Please select a template',
            },
        },
    },
    // {
    //     name: 'Select Template',
    //     when: ['Design My File (upload required) +$65'],
    //     item: {
    //         label: 'Drop Your Design File Here!',
    //         name: 'Drop Your Design File Here!',
    //         required: true,
    //         allowed_types: 'image_document',
    //         type: 'fileupload',
    //         maxFiles: 10,
    //     },
    // },
    {
        name: 'Select Template',
        when: [
            'Designed Tri-Fold is on File',
            'Designed Postcard is on File',
            'Designed Letter is on File',
            'Designed Envelope is on File',
            'Select a Previously Designed File',
        ],
        item: {
            label: 'Previous order',
            name: orderNoForDesignFieldName,
            required: true,
            type: 'combo',
            shouldLoggedin: true,
            shouldLoadOptions: true,
            loadFunction: fetchLoggedInCustomerOrders,
            loadFreshFunction: fetchLoggedInCustomerOrders,
            options: ['Loading...'],
            description: 'Select the order you want to reuse.',
        },
    },
    {
        name: 'Select Template',
        when: ['Select a Previously Designed File'],
        exclude: ['create-your-own-campaign'],
        item: {
            label: 'Duplicate this order',
            name: duplicatePreviousOrderFieldName,
            required: false,
            type: 'checkbox',
            value: false,
            description:
                'Copies the design, postage, and upgrades from this order. You will choose a new mailing list and mailing schedule.',
        },
    },
    {
        name: 'Select Template',
        when: [
            'Designed Tri-Fold is on File',
            'Designed Postcard is on File',
            'Designed Letter is on File',
            'Designed Envelope is on File',
        ],
        item: {
            label: 'Does this mailer need edits?',
            name: 'Does this mailer need edits?',
            required: true,
            type: 'toggle',
            value: false,
        },
    },
    {
        name: 'Letterhead',
        when: ['Use Your Own Logo'],
        item: {
            label: 'Logo',
            name: 'logo',
            required: true,
            allowed_types: 'image_document',
            type: 'fileupload',
        },
    },
    // {
    //     name: 'Logo',
    //     when: ['Use Your Own Logo'],
    //     item: {
    //         label: 'Logo',
    //         name: 'logo',
    //         required: true,
    //         allowed_types: 'image_document',
    //         type: 'fileupload',
    //     },
    // },
    {
        name: 'Logo',
        when: ['Use Your Own Logo'],
        item: {
            label: 'Select Design Files',
            name: 'logo',
            allowed_types: 'image',
            type: 'choose-modal',
            maxFiles: 50,
            modal: SelectDesignModal,
            required: true,
            description:
                'Upload new files or pick from your saved library — logos, headshots, designs, copy. Uploads are saved to your account so you can reuse them next time.',
            message: 'Please Select a Design File',
            error: {
                required: 'Please Select a Design File',
                maxFiles: 'You can only upload 50 files',
            },
        },
    },
    {
        name: 'Batch Mailing',
        when: [
            '2 Batches',
            '3 Batches',
            '4 Batches',
            '5 Batches',
            '6 Batches',
            '7 Batches',
            '8 Batches',
        ],
        item: {
            label: 'If Batched, Send Every',
            name: 'Send Batch Every',
            required: true,
            type: 'select',
            options: [
                // 'Not Applicable',
                'Week',
                '2 Weeks',
                '3 Weeks',
                '4 Weeks',
            ],
        },
    },
    {
        name: 'Select Template',
        when: ['Call Today, Sell Tomorrow'],
        item: {
            label: 'Message (Optional)',
            name: 'Message (Optional)',
            required: false,
            type: 'textarea',
            defaultValue:
                'Dear [[first]], We are interested in purchasing your property at [[propaddress]]. I am a serious buyer with CASH. Please call me at [[phone]] to discuss my offer. Thanks! [[Signature]]',
        },
    },
    {
        name: 'Select Template',
        when: ['You Have Options'],
        item: {
            label: 'Message (Optional)',
            name: 'Message (Optional)',
            required: false,
            type: 'textarea',
            defaultValue:
                'Dear [[first]], We have been faced with a very difficult year but I want you to know that you have options when it comes to your property at [[propaddress]]. I am here to answer any questions you have and alleviate your financial stress. [[Signature]] [[phone]]',
        },
    },
    {
        name: 'Select Template',
        when: ['Realtor'],
        item: {
            label: 'Message (Optional)',
            name: 'Message (Optional)',
            required: false,
            type: 'textarea',
            defaultValue:
                'Dear [[first]], Would you consider an offer for your house? Your house meets the criteria of a very qualified client of mine. They are in a position to make an offer and pay CASH. If so, please call me on my cell phone at [[phone]]. Sincerely, [[Signature]]',
        },
    },
]

export const getConditinalField = (item, value, product = null) => {
    return conditionalFields.filter((field) => {
        const isExcluded =
            product?.slug && Array.isArray(field.exclude)
                ? field.exclude.includes(product.slug)
                : false

        return (
            !isExcluded &&
            (item.name === field.name || item.name.includes(field.name)) &&
            field.when.includes(value)
        )
    })
}

export const realPennedEnvelopeFieldName = 'Real Penned Envelope'
export const appearanceFieldNames = [
    'Font Style',
    'Font Color',
    'Check Color',
    'Handwriting Style',
    'Letter Font Style',
    'Envelope Style',
    'Envelope Font Style',
    'Envelope Font Color',
    'Flyer Style',
    'Postcard Style',
]

export const specialFieldsToExcludeForMultiTouch = [
    selectTemplateField.name,
    logoField.name,
    'Postage',
    'Postcard Size',
    // Note: realPennedEnvelopeFieldName is NOT excluded so it can appear for each mailer
    'Postcard Size',
]

// CYO field preparation must not mutate the shared catalog between touches.
export const getCYOFields = (products, value, key, options) => {
    const selected = products.find(({ name }) => name === value)
    const prepareNestedFields = (field) => ({
        ...field,
        label: field.label || field.name.replace(`${key} `, ''),
        name: makeFieldMultiTouch(field.name, key),
        mailerKey: key,
        ...(Array.isArray(field.fields)
            ? { fields: field.fields.map(prepareNestedFields) }
            : {}),
    })
    return selected
        ? getMultiTouchFields([cloneDeep(selected)], value, key, options).map(
              (field) => {
                  const prepared = prepareNestedFields(field)
                  return field.name === `${key} ${postageFieldName}` ||
                      field.name === `${key} ${postcardSizeFieldName}`
                      ? { ...prepared, type: 'select', isAttribute: false }
                      : prepared
              },
          )
        : []
}

export const getMultiTouchFields = (
    products,
    value,
    key,
    { streetviewLocked = false } = {},
) => {
    const product = products.find(({ name }) => name === value)

    let fields = product?.attributes || []

    let acfFields = product?.acfFields || []
    acfFields = prepareFields(acfFields)

    const getRequiredValue = (item) => {
        // this was added on 16 oct 2024 for this ticket
        // https://trello.com/c/0OKiChU2/46-edit-message-required
        return item?.isAddOnField ? item.required : Boolean(item?.required)
    }

    const prepareForMultiTouch = (fields) => {
        fields = fields.filter((field) => Boolean(field?.name))

        // console.log('prepareForMultiTouch', fields)

        return fields.map((item) => {
            item.name = makeFieldMultiTouch(item.name, key)
            item.originalName = item.name
            item.isPrecustomizationField = true
            item.required = getRequiredValue(item)
            item.isAttribute = false
            item.mailerKey = key
            return item
        })
    }

    const isThisMultiTouchProduct = true

    const preCustomizationFields =
        fields.length > 0
            ? prepareForMultiTouch(
                  getPreCustomizationFields(
                      fields,
                      { slug: convertToSlug(value) },
                      isThisMultiTouchProduct,
                      { streetviewLocked },
                  ),
              )
            : []

    let acfFieldsForMultiTouchFirstStep =
        acfFields?.['step_1']?.length > 0
            ? prepareForMultiTouch(acfFields['step_1'])
            : []

    const nonRequiredAcfFields = ['Additional Files', 'Comments']
    // remove required for multiple filed
    acfFieldsForMultiTouchFirstStep = acfFieldsForMultiTouchFirstStep.map(
        (item) => {
            const nonRequired = nonRequiredAcfFields.some((field) =>
                item.name.includes(field),
            )
            return {
                ...item,
                required: nonRequired ? false : item.required,
            }
        },
    )

    if (!fields || fields.length < 1) return []

    // Filter out pre-customization fields from attributes before preparing for multi-touch
    const filteredAttributes = removeFieldsFromAttributes(product.attributes)
    fields = prepareAttributesMultiTouch(filteredAttributes, key)

    // remove excluded fields
    fields = fields.filter(
        (item) =>
            !specialFieldsToExcludeForMultiTouch.some((excludedField) =>
                item.name.includes(excludedField),
            ),
    )

    return acfFieldsForMultiTouchFirstStep.length > 0
        ? [
              ...preCustomizationFields,
              ...fields,
              ...acfFieldsForMultiTouchFirstStep,
          ]
        : [...preCustomizationFields, ...fields]

    // return [...preCustomizationFields, ...fields]
}

export const getMultiTouchProperties = (products, value, key) => {
    const product = products.find(({ name }) => name === value)

    if (product) {
        return {
            fields: prepareAttributesMultiTouch(product.attributes, key),
            default_templates_attributes: product.default_templates_attributes,
            templates_and_attributes: product.templates_and_attributes,
            product: product.product,
        }
    }
    return {
        fields: [],
    }
}

export const isMultiTouchField = (item) => isMultiTouchFieldBase(item.name)
export const isMultiTouchFieldBase = (name) =>
    name.includes(MultiTouchField.name)

export const shouldExcludeForMultiTouchSingleProduct = 'Postage'

export const postageFieldName = 'Postage'
export const standardClassPostage =
    'Standard Class (5-20 day delivery after your mail date)'
export const handWritingFieldName = 'Handwriting Style'
export const envelopeOptionFieldName = 'Envelope Option'
export const streetviewImageFieldName = 'Add Streetview Image'
export const postcardSizeFieldName = 'Postcard Size'

export const fieldsNameWhichAreNotCustomizableMailOptions = [
    postageFieldName,
    postcardSizeFieldName,
    handWritingFieldName,
    envelopeOptionFieldName,
    streetviewImageFieldName,
    //realPennedEnvelopeFieldName,
    selectTemplateField.name,
    logoField.name,
    customizeMailPieceField.name,
]

export const isPostageField = (item) => {
    return (
        item.name === postageFieldName || item?.name?.includes(postageFieldName)
    )
}

export const isHandwritingField = (item) => {
    return (
        item.name === handWritingFieldName ||
        item?.name?.includes(handWritingFieldName)
    )
}

export const isEnevelopOptionField = (item) => {
    return (
        item.name === envelopeOptionFieldName ||
        item?.name?.includes(envelopeOptionFieldName)
    )
}

export const isStreetviewImageField = (item) => {
    return (
        item.name === streetviewImageFieldName ||
        item?.name?.includes(streetviewImageFieldName)
    )
}

export const isPostcardSizeField = (item) => {
    return (
        item.name === postcardSizeFieldName ||
        item?.name?.includes(postcardSizeFieldName)
    )
}
export const isRealPennedEnvelopeField = (item) => {
    const normalizedName = realPennedEnvelopeFieldName.toLowerCase()

    const itemName = String(item?.name || '').toLowerCase()
    const itemLabel = String(item?.label || '').toLowerCase()

    const nameMatch =
        itemName === normalizedName || itemName.includes(normalizedName)
    const labelMatch =
        itemLabel === normalizedName || itemLabel.includes(normalizedName)

    return nameMatch || labelMatch
}

export const isAppearanceField = (item) => {
    const itemName = String(item?.name || '')
    return appearanceFieldNames.some((fieldName) =>
        itemName.includes(fieldName),
    )
}

export const isPurchaseListField = (item) => {
    return item.name === purchaseField.name
}

export const getPostageField = (attributes) => {
    if (!attributes) return null
    return attributes.find((item) => isPostageField(item))
}

export const getHandWritingField = (attributes) => {
    if (!attributes) return null
    return attributes.find((item) => isHandwritingField(item))
}

export const getEnevelopeOptionField = (attributes) => {
    if (!attributes) return null
    return attributes.find((item) => isEnevelopOptionField(item))
}

export const getStreetviewImageField = (attributes) => {
    if (!attributes) return null
    return attributes.find((item) => isStreetviewImageField(item))
}

export const getPostcardSizeField = (attributes) => {
    if (!attributes) return null
    return attributes.find((item) => isPostcardSizeField(item))
}
export const getRealPennedEnvelopeField = (attributes) => {
    if (!attributes) return null
    return attributes.find((item) => isRealPennedEnvelopeField(item))
}

export const modifiedAttributes = [logoField]
export const removedAttributes = [logoField, selectTemplateField]

export const modifyAttributesFields = (attributes) => {
    const attrs = attributes
        .map((item) => {
            const modified = modifiedAttributes.find(
                (modifiedItem) => modifiedItem.name === item.name,
            )
            return modified ? modified : item
        })
        .filter((item) => {
            const shouldRemove = removedAttributes.find(
                (toRemove) => toRemove.name === item.name,
            )
            return shouldRemove ? false : true
        })
    // there is a caveat, suppose logo is removed from backend, and it says Logo in backend in order details.
    // but Select Design File on frontend, then there will be no select design on frontend.

    // log('modifyAttributesFields', attrs)
    return attrs
}

export const prepareAttributesMultiTouch = (attributes, key) => {
    const allAttrs = attributes.map((item) => {
        const required = item.visible
        item.type = 'select'
        item = item.name == logoField.name ? { ...logoField } : item
        return {
            ...item,
            label: item.label || item.name,
            name: `${key} ${item.name}`,
            required: required,
            mailerKey: key,
            isAttribute: true,
        }
    })

    return allAttrs.filter((item) => {
        return (
            !item.name.includes(shouldExcludeForMultiTouchSingleProduct) &&
            !isAppearanceField(item)
        )
    })
}

export const prepareAttributes = (attributes, product) => {
    const attrs = attributes.map((item) => {
        const required = item.visible
        return {
            ...item,
            type: 'select',
            isAttribute: shouldNotFollowNewOrderProcess(product) ? false : true,
            required: required,
        }
    })

    return modifyAttributesFields(attrs)
}

export const handleDesignOnFile = ({
    selectedItem,
    getValues,
    stepsFields,
    setStepsAndFields,
}) => {
    const exemptedFields = ['Batch Mailing']

    if (exemptedFields.includes(selectedItem.name)) return

    const fieldsObject = {
        'Select Template': {
            valuesToMatch: [
                'Designed Letter is on File',
                'Designed Postcard is on File',
                'Designed Tri-Fold is on File',
                // 'Designed Envelope is on File',
            ],
            excluded: [
                'Font Style',
                'Font Color',
                // 'Envelope Style',
                // 'Envelope Font Style',
                // 'Envelope Font Color',
                'Logo',
                'Letter Font Style',
                'Flyer Style',
                'Postcard Style',
            ],
        },
    }

    let fieldsToSet = [...stepsFields]

    const values = getValues()
    const intersected = intersection(
        Object.keys(values),
        Object.keys(fieldsObject),
    ).filter((item) => values[item] !== null)

    if (intersected.length < 1) return

    intersected.forEach((key) => {
        const value = values[key]
        const { valuesToMatch, excluded } = fieldsObject[key]
        if (valuesToMatch.includes(value)) {
            let edited = [...stepsFields]
            edited[0].fields = edited[0].fields.filter((field) => {
                return !excluded.includes(field.name)
            })
            fieldsToSet = edited
        }
    })

    setStepsAndFields(fieldsToSet)
}

export const streetviewYesOptionValue = 'Yes (+$0.02)'

export const isStreetviewTemplateName = (templateName) => {
    if (!templateName) return false
    return /gsv|streetview/i.test(String(templateName))
}

export const getPreCustomizationFields = (
    attributes,
    product,
    isThisMultiTouchProduct,
    { streetviewLocked = false } = {},
) => {
    let attrFields = []
    let upgradeFields = []
    let appearanceFields = []

    const shouldAddPostageField =
        isObject(getPostageField(attributes)) &&
        (isThisMultiTouchProduct || !isCYOProduct(product))

    if (shouldAddPostageField) {
        let postageField = { ...getPostageField(attributes) }
        postageField.isAttribute = false
        postageField.value = standardClassPostage
        postageField.defaultValue = standardClassPostage
        attrFields.push(postageField)
    }

    if (isObject(getPostcardSizeField(attributes))) {
        let postcardSizeField = { ...getPostcardSizeField(attributes) }
        postcardSizeField.isAttribute = false
        attrFields.push(postcardSizeField)
    }

    if (isRealPennedProduct(product) || isRealPennedPostcardProduct(product)) {
        // Envelope Option Field
        let envelopeOptionField = { ...getEnevelopeOptionField(attributes) }
        // Only push if we actually found a valid envelope option field
        if (Object.keys(envelopeOptionField).length > 0) {
            envelopeOptionField.isAttribute = false
            attrFields.push(envelopeOptionField)
        }
    }

    // For Personal/Professional Letters: Extract "Upgrade to Real Penned Envelope?" from attributes
    if (
        isPersonalLetterProduct(product) ||
        isProfessionalLetterProduct(product)
    ) {
        let realPennedEnvelopeField = getRealPennedEnvelopeField(attributes)

        if (isEmpty(realPennedEnvelopeField)) {
            realPennedEnvelopeField = { ...realPennedEnvelopeFieldDefinition }
        } else {
            realPennedEnvelopeField = { ...realPennedEnvelopeField }
        }

        realPennedEnvelopeField.name = realPennedEnvelopeFieldName
        realPennedEnvelopeField.label = realPennedEnvelopeFieldName
        realPennedEnvelopeField.isAttribute = false
        realPennedEnvelopeField.toggleVariant = 'upgrade'
        realPennedEnvelopeField.priceLabel = '+$0.10/pc'
        realPennedEnvelopeField.required = false
        realPennedEnvelopeField.value = 'No'
        realPennedEnvelopeField.defaultValue = 'No'
        realPennedEnvelopeField.description =
            realPennedEnvelopeField.description ||
            'A genuine handwritten address on the outer envelope to lift open rates.'
        upgradeFields.push(realPennedEnvelopeField)
    }

    if (
        !isRealPennedProduct(product) &&
        product?.slug !== 'snap-pack-check-mailers-ros'
    ) {
        // Streetview Image Field
        let streetviewImageFieldObj = { ...getStreetviewImageField(attributes) }
        if (isEmpty(streetviewImageFieldObj)) {
            streetviewImageFieldObj = { ...streetviewImageField }
        }

        if (!isEmpty(streetviewImageFieldObj)) {
            streetviewImageFieldObj.isAttribute = false
            streetviewImageFieldObj.toggleVariant = 'upgrade'
            streetviewImageFieldObj.priceLabel =
                streetviewImageFieldObj.priceLabel ||
                streetviewImageField.priceLabel
            streetviewImageFieldObj.description =
                streetviewImageFieldObj.description ||
                streetviewImageField.description
            if (streetviewLocked) {
                streetviewImageFieldObj.disabled = true
            }
            upgradeFields.push(streetviewImageFieldObj)
        }
    }

    if (shouldAddPagesAndPrinting(product)) {
        upgradeFields.push({
            ...pagesAndPrintingField,
            isAttribute: false,
            isAddOnField: true,
        })
    }

    if (!isCYOProduct(product)) {
        upgradeFields.push({
            ...AddOfferField,
            isAttribute: false,
            isAddOnField: true,
        })
    }

    if (upgradeFields.length > 0) {
        attrFields.push({ ...upgradesSectionField }, ...upgradeFields)
    }

    appearanceFields = attributes
        .filter((field) => isAppearanceField(field))
        .map((field) => ({
            ...field,
            type: 'select',
            isAttribute: true,
            required: false,
        }))

    let fields = [{ ...selectTemplateField }, ...attrFields]

    if (appearanceFields.length > 0) {
        fields.push({
            ...appearanceSectionField,
            fields: appearanceFields,
        })
    }

    fields.push({ ...logoField })

    if (attrFields.length != attributes.length && appearanceFields.length < 1) {
        fields.push({ ...customizeMailPieceField })
    }
    return fields.filter((item) => !isUndefined(item) && !isNull(item))
}

export const isReturnedMailProduct = (product) =>
    product.slug?.includes('olm-returned')

export const shouldNotFollowNewOrderProcess = (product) => {
    return (
        isCampaignProduct(product) ||
        isSkipTrace(product) ||
        isLeadListProduct(product) ||
        isReturnedMailProduct(product)
    )
}

export const shouldFollowNewOrderProcess = (product) => {
    return !shouldNotFollowNewOrderProcess(product)
}

export const mayBeAddSelectDesignField = (fields, product) => {
    if (isProvenMixProduct(product)) return [...fields, logoField]
    return fields
}

export const removeFieldsFromAttributes = (attributes) => {
    return attributes.filter((item) => {
        const isPostage = isPostageField(item)
        const isHandwriting = isHandwritingField(item)
        const isEnvelopeOption = isEnevelopOptionField(item)
        const isRealPennedEnvelope = isRealPennedEnvelopeField(item)
        const isStreetview = isStreetviewImageField(item)

        return (
            !isPostage &&
            !isHandwriting &&
            !isEnvelopeOption &&
            !isRealPennedEnvelope &&
            !isStreetview
        )
    })
}

export const prepareFields = (fields) => {
    const additionalFilesFieldName = 'Additional Files'
    const commentsFieldName = 'Comments'
    const stepOneFields = Array.isArray(fields?.step_1) ? fields.step_1 : []
    const stepThreeFields = Array.isArray(fields?.step_3) ? fields.step_3 : []

    const commentsField = stepOneFields.find((item) =>
        item?.name?.includes(commentsFieldName),
    )

    for (let step in fields) {
        if (Array.isArray(fields[step])) {
            fields[step] = fields[step]
                .filter(
                    (item) =>
                        !item?.name?.includes(additionalFilesFieldName) &&
                        !(
                            step === 'step_1' &&
                            item?.name?.includes(commentsFieldName)
                        ),
                )
                .map((item) => {
                    if (step === 'step_1') {
                        return {
                            ...item,
                            isAddOnField: true,
                        }
                    }
                    return {
                        ...item,
                    }
                })
        }
    }

    if (commentsField) {
        fields.step_3 = [...stepThreeFields, commentsField]
    }

    return fields
}

export const getPostageValueFromGetValues = (values) => {
    return values[postageFieldName]
}

export const getStepsAndFields = ({
    attributes,
    fields,
    quantity,
    totalSteps = 1,
    product,
    multiTouchProducts,
    getValues,
    streetviewLocked = false,
}) => {
    // @note
    // getValues is here to pass further, making show/notshow fields based on it here
    // ends up in infinite loop, so we are passing it further

    let steps = []

    let attributeFields = prepareAttributes(attributes, product)
    fields = prepareFields(fields)

    const sampleLeadList = {
        name: 'Sample Lead List',
        type: 'sample-lead-list-info',
    }

    const shouldAddSampleListInfo =
        !isServiceProduct(product) && !isSubscriptionProduct(product)

    const sampleLeadListFields = shouldAddSampleListInfo ? [sampleLeadList] : []

    const preCustomizationFields = shouldNotFollowNewOrderProcess(product)
        ? [...sampleLeadListFields]
        : [
              ...sampleLeadListFields,
              ...getPreCustomizationFields(
                  attributeFields,
                  product,
                  undefined,
                  {
                      streetviewLocked,
                  },
              ),
          ]

    if (isCYOProduct(product)) {
        // CYO now asks postage per mailer step, so hide root/global Postage.
        attributeFields = attributeFields.filter(
            (item) => !isPostageField(item),
        )
    }

    // Only remove fields from attributes that were actually added to pre-customization.
    if (!shouldNotFollowNewOrderProcess(product)) {
        // Get the field names that were added to pre-customization
        const preCustomFieldNames = getPreCustomizationFields(
            attributeFields,
            product,
            undefined,
            { streetviewLocked },
        ).flatMap((field) =>
            field.type === appearanceSectionField.type &&
            Array.isArray(field.fields)
                ? [field.name, ...field.fields.map((item) => item.name)]
                : [field.name],
        )

        // Only remove those specific fields from attributes
        attributeFields = attributeFields.filter((item) => {
            const shouldRemove = preCustomFieldNames.includes(item.name)
            return !shouldRemove
        })
    }

    let stepOneFields = fields?.['step_1']
        ? [...preCustomizationFields, ...attributeFields, ...fields['step_1']]
        : [...preCustomizationFields, ...attributeFields]

    stepOneFields = mayBeAddSkipTraceFields(stepOneFields, product)
    stepOneFields = mayBeAddSelectDesignField(stepOneFields, product)

    if (shouldAddShipping(product.slug)) {
        stepOneFields = [
            ...stepOneFields,
            getShippingField({ quantity, product }),
        ]
    }

    if (isMultiTouchProduct(product)) {
        stepOneFields = removeExtraMultiTouchFields(stepOneFields)
    }

    // log('stepOneFields from fn', stepOneFields)

    const stepTwoFields = fields?.['step_2']
        ? [
              mappingListGroupField,
              ...fields['step_2'],
              ...getAdditionalFieldsForProduct(product, getValues),
          ]
        : [
              mappingListGroupField,
              ...getAdditionalFieldsForProduct(product, getValues),
          ]

    const batchOptions = getBatchOptions(quantity, product, getValues)

    let stepThreeFields = fields?.['step_3']
        ? [...batchOptions, ...fields['step_3']]
        : [...batchOptions]

    stepThreeFields = [...stepThreeFields, checkTOSField]

    // if(isCYOProduct(product)){
    //     stepThreeFields = [...stepThreeFields, ...getAdditionalFieldsForProduct(product, getValues())]
    // }

    let styleStep = {
        name: isMultiTouchProduct(product)
            ? 'Number of touches'
            : 'Design & options',
        fields: [...stepOneFields],
    }

    let mailingStep = {
        name: 'Your mailing list',
        description: isMultiTouchProduct(product)
            ? "Upload your mailing list and map your columns to ours. We'll remove undeliverable and duplicate addresses before anything mails. The same list is used for every touch."
            : "Upload your mailing list and map your columns to ours. We'll remove undeliverable and duplicate addresses before anything mails.",
        fields: [...stepTwoFields],
    }

    log2('mailingStep', mailingStep)

    let buyingStep = {
        name: 'Schedule & review',
        description: isMultiTouchProduct(product)
            ? 'Your touches mail in sequence. Set how far apart each one goes out, then pick your first mailing date. To guarantee a specific date, place your order 4 business days ahead and approve your proof the day you receive it.'
            : 'You may also specify the date of your first mailing. To guarantee mailing on a specified date, your order should be placed 4 business days prior and proof approval must be made on the date received. Any changes to your proof may delay your mailing.',
        fields: [...stepThreeFields],
    }

    steps.push(styleStep) // this is going to first one

    /** Steps for Multi Touch */
    let multitouches = []
    if (isMultiTouchProduct(product)) {
        const touches = totalSteps - 3
        const productsNames = getMultiTouchOptions(multiTouchProducts)
        const postageValue = getPostageValueFromGetValues(getValues())

        // this filtered based on postage, like streetview can only be sold when its
        // first class
        const filteredProductOptions = excludedProductBasedOnPostage(
            postageValue,
            productsNames,
        )

        log2('filteredProductOptions', postageValue, filteredProductOptions)

        for (let index = 0; index < touches; index++) {
            const fields = generateMultiTouchProductField(
                index,
                filteredProductOptions,
            )
            multitouches.push(fields)
        }
        steps.push(...multitouches)
    }

    // these should be last two steps
    steps.push(mailingStep)
    steps.push(buyingStep)

    return steps.slice(0, totalSteps)
}

export const excludedProductBasedOnPostage = (postageValue, productsNames) => {
    if (!postageValue) return productsNames

    const postageStandardExcludeProducts = []
    const postageFirstClassExcludedProducts = []

    return postageValue.includes('Standard')
        ? productsNames.filter(
              (name) => !postageStandardExcludeProducts.includes(name),
          )
        : postageValue.includes('First Class')
        ? productsNames.filter(
              (name) => !postageFirstClassExcludedProducts.includes(name),
          )
        : productsNames
}

const getMultiTouchOptions = (products) => products.map(({ name }) => name)
const generateMultiTouchProductField = (index, options) => {
    const field = { ...MultiTouchField }
    field.name = `${field.name} ${index + 1}`
    field.options = options
    return {
        name: `Mailer ${index + 1}`,
        description: 'Choose the product and design options for this touch.',
        fields: [field],
    }
}

export const fonts = [
    {
        keyword: ['cursive'],
        font: 'font-cursive',
    },
    {
        keyword: ['print'],
        font: 'font-print',
    },
    {
        keyword: ['albany'],
        font: 'font-albany',
    },
    {
        keyword: ['boston'],
        font: 'font-boston',
    },
    {
        keyword: ['columbus'],
        font: 'font-columbus',
    },
    {
        keyword: ['denver'],
        font: 'font-denver',
    },
    {
        keyword: ['hartford'],
        font: 'font-hartford',
    },
    {
        keyword: ['phoenix', 'phoenix - personal'],
        font: 'font-phoenix',
    },
    {
        keyword: ['richmond'],
        font: 'font-richmond',
    },
    {
        keyword: ['seattle'],
        font: 'font-seattle',
    },
    {
        keyword: ['trenton'],
        font: 'font-trenton',
    },
]

export const getProductImages = async (product) =>
    await Promise.all(
        product.images.map(async (image) => {
            try {
                const data = await GeneralAPI.getMediaByid(image.id)
                const thumbnail =
                    data.media_details.sizes.woocommerce_thumbnail.source_url

                return {
                    original: image.src,
                    thumbnail,
                    originalAlt: image.alt,
                    thumbnailAlt: image.alt,
                    originalTitle: data.title.rendered,
                    thumbnailTitle: data.title.rendered,
                }
            } catch (e) {
                log(e.message)
                return null
            }
        }),
    )

export const findFont = (keyword) => {
    const item = fonts.find((font) =>
        font.keyword.includes(keyword.toLowerCase()),
    )
    return item?.font ? item.font : ''
}

export const isSimpleProduct = (product) => product.type === 'simple'

export const isALetterProduct = (product) =>
    product && product.slug.includes('letter')
export const isAFlyerProduct = (product) =>
    product && product.slug.includes('flyer')
export const isAPostCardProduct = (product) =>
    product && product.slug.includes('flyer')

export const isNotALetterProduct = (product) => !isALetterProduct(product)

export const getTieredPrice = (priceRulesObject, quantity, type, price) => {
    let finalPrice
    const rulekeys = keys(priceRulesObject).map(Number) // Convert to numbers

    const isLowerThanMinimum = rulekeys[0] > quantity // Now if first key is less than quantity, we will simply use price.

    if (isLowerThanMinimum) {
        finalPrice = price
    } else {
        const allkeys = rulekeys.filter((qtn) => qtn <= quantity) // it will get us all matches one and we will use last one
        const ruleKey = rulekeys[allkeys.length - 1]

        // console.log('priceRulesObject', priceRulesObject, ruleKey)

        const finalRule = priceRulesObject[ruleKey]
        finalPrice =
            type === 'percentage' ? price * (finalRule / 100) : finalRule
    }

    return finalPrice
}

export const getPrice = (product, quantity, multiplier = 1) => {
    // there are two cases, once it does have tier price, and it does not have tier price
    // if it does have tier price, we will use tier price, else sale_price || price

    // console.log('getPrice', product, quantity)

    // @NOTE - 13 oct 2020 - going forward we will be using tier price of actual quantity.
    // https://www.notion.so/open-letter-marketing/31f9d2caf7d7406ea4619c1fe466b442?v=c3676c0e9f1640879366b353b9737572&p=161f3ae2db404428926038dbc08b0d2d&pm=s
    multiplier = 1

    if (!product) return

    const {
        price,
        sale_price,
        tiered_pricing_fixed_rules: fixedRules,
        tiered_pricing_percentage_rules: percentageRules,
        tiered_pricing_type: type,
    } = product

    quantity = quantity * multiplier // this make sense when its multitouch/campaign product.

    // if tiered_pricing_type is fixed, we will use tiered_pricing_fixed_rules
    // if tiered_pricing_type is percentage, we will use tiered_pricing_percentage_rules
    // if tiered_pricing_type and relevant rules are not provided, we will use sale_price || price

    const useableRules = type === 'percentage' ? percentageRules : fixedRules
    const mainPrice = Number(sale_price) ? sale_price : Number(price)

    // when tiered pricing is not used. its returns blank array else object
    const InvalidTiersPricing =
        Array.isArray(useableRules) && useableRules.length === 0

    return InvalidTiersPricing
        ? mainPrice
        : getTieredPrice(useableRules, quantity, type, price)
}

export const isServiceProduct = (product) => {
    if (!product) return false
    const categories = product.categories
    if (!categories) return false
    return categories.find((item) => item.slug === 'services')
}

export const isServiceProductBySlug = (product) => {
    return product.includes('service')
}

export const getMinQuantity = (item) => {
    const product = item?.item || item
    if (!product) return 200
    //is LIST source
    if (product.slug?.includes('real-estate-investment-lead-lists')) return 1
    if (isCYOProduct(product)) return 500
    if (product.tiered_pricing_minimum_quantity > 0)
        return product.tiered_pricing_minimum_quantity

    const metaValue = Number(
        product.meta_data?.find((m) => m.key === 'minimum_allowed_quantity')
            ?.value,
    )
    return metaValue > 0 ? metaValue : 200
}

/**
 * MultiTouch
 * So basically this is how interface of it should be
 * its multitouch Campaign
 * First user select how many touches they want to add, based on that steps are decided.
 * Now once they choose it, they go to next step
 * the first thing they choose is touch type,
 * once they do that based on touch product relavant fields are shows and this process goes on for all the touches.
 * and then simple lead upload and batching.
 *
 * @Technical
 * So when touches are selected
 */

export const TouchesFieldName = 'Touches'
export const isMultiTouchProduct = (product) => {
    if (!product) return false
    return product.slug && product.slug.includes('create-your-own-campaign')
}
export const isCYOProduct = (product) => {
    if (!product) return false
    return product.slug && product.slug.includes('create-your-own-campaign')
}
export const isProvenMixProduct = ({ slug }) => slug === 'proven-mix-campaigns'
export const isCampaignProduct = (product) => {
    const slug = product?.slug
    if (!slug) return false
    return (
        isMultiTouchProduct({ slug }) ||
        isProvenMixProduct({ slug }) ||
        String(slug).includes('campaign')
    )
}

export const isAServiceProduct = ({ slug }) => slug.includes('service')

export const isLeadListProduct = ({ name, slug }) => {
    return slug
        ? slug.includes('lead-list')
        : name.toLowerCase().includes('lead list')
}

export const getCampaingTouches = (values) => {
    // we assume these attributes would not be in any other product
    // @TODO should be one value for both in backend.
    const value = values['Touches'] || values['Number of Touches']
    return value ? convertStep(value) : 1
}
export const getTotalCampaingProduct = (item) => {
    const quantity = getTotalQuantityCampaignProduct(item)
    return Number(quantity) * Number(item.price)
}

export const getTotalQuantityCampaignProduct = (item) => {
    const { quantity } = item
    const touches = getCampaingTouches(item)
    return Number(quantity) * Number(touches)
}

export const currentTouchesValue = (getValues) => {
    const values = getValues()
    const value = getCampaingTouches(values)
    return value ? value : 1
}
export const shouldChangeTotalSteps = (product, item) =>
    isMultiTouchProduct(product) && item.name === TouchesFieldName

export const shouldChangeMultiTouchStepFields = (product, item) =>
    isMultiTouchProduct(product) && isMultiTouchField(item)

export const isTwoSteps = (slug) =>
    [
        'real-penned-letters',
        'real-penned-professional-letters',
        'real-penned-postcards',
        // 'autopen-letters',
        // 'autopen-postcards',
        // 'dynamic-campaign-mailer-2',
        // 'dynamic-campaign-mailer',
    ].includes(slug)

export const stepObj = {
    Two: 2,
    Three: 3,
    Four: 4,
    Five: 5,
    Six: 6,
}

export const convertStep = (step) => stepObj[step]

export const totalStepsForMultiTouch = (value) => {
    const defaultSteps = 3
    return convertStep(value) + defaultSteps
}

export const getTotalSteps = (product, value = 3) => {
    if (isMultiTouchProduct(product)) return value
    return isTwoSteps(product.slug) ? 2 : isServiceProduct(product) ? 1 : 3
}

export const MultiTouchField = {
    label: 'Mailer Type',
    required: true,
    name: 'Mailer Type',
    type: 'select',
    options: [],
}

export const isVariableSubscription = (product) =>
    product.type === 'variable-subscription'
export const isSimpleSubscription = (product) => product.type === 'subscription'
export const isSubscriptionProduct = (product) =>
    isVariableSubscription(product) || isSimpleSubscription(product)

export const getMaxLength = (slug) => {
    const greaterLimit = ['real-penned-letters']
    return greaterLimit.includes(slug) ? 300 : 265
}

export const shouldShowshipping = (items) => {
    return items.some((item) => {
        return (
            item.permalink.includes('real-penned-letters') ||
            item.permalink.includes('real-penned-professional-letters')
        )
    })
}

export const shouldShowshippingFromOrder = (items) => {
    return items.some((item) => {
        if (item.name.includes('Real Penned')) {
            const mailForcustomerMeta = findMetaDataByKey(
                item,
                realPennedAdditionalFields.name,
            )
            return (
                String(mailForcustomerMeta?.value).toLocaleLowerCase() === 'no'
            )
        } else if (item.name.includes('Create Your Own Campaign')) {
            const mailForcustomerMeta = findMetaDataByKey(
                item,
                realPennedAdditionalFields.name,
            )
            return (
                String(mailForcustomerMeta?.value).toLocaleLowerCase() === 'no'
            )
        }
        return false
    })
}

export const isRosProduct = (productName) => productName?.includes('ros')

export const rosField = {
    name: 'ROS Offer',
    required: true,
    message: 'Please Choose ROS Offer.',
}
export const rosOfferPercentage = {
    name: 'ROS Offer Percentage',
}

export const isSkipTrace = (product) => product.slug?.includes('skip-trace')

const mayBeAddSkipTraceFields = (fields, product) => {
    return isSkipTrace(product) ? [...leadFields, ...fields] : fields
}

export const hasLeadFileInput = (stepsAndFields) => {
    const allFields = flatten(
        stepsAndFields.map((step) => {
            return step.fields
        }),
    )

    return allFields.find((field) => field.name === LeadFieldName)
}

export const calculateCYOPricingBasedOnProducts = (
    values,
    multiTouchProducts,
    quantity,
) => {
    // console.log(
    //     'calculateCYOPricingBasedOnProducts',
    //     quantity,
    //     multiTouchProducts,
    // )
    return calculateAveragePrice(values, multiTouchProducts, quantity)
}

export const GetAddOfferValueFromGetValues = (data) => {
    return (
        data[AddOfferField.name] &&
        AddOfferField.paidOption.includes(data[AddOfferField.name])
    )
}

export const filterMaileTypesFromGetValues = (data) => {
    return Object.fromEntries(
        Object.entries(data).filter(
            ([key]) => /Mailer Type \d+$/.test(key), // Regular expression to match "Mailer Type" followed by a space and one or more digits
        ),
    )
}

/**
 *
 * param data getValues()
 */
export const shouldChooseCYOOffer = (values) => {
    const touches = convertStep(values[TouchesFieldName]) || 0
    return Array.from({ length: touches }, (_, index) => {
        const key = `Mailer Type ${index + 1}`
        const choice = values[`${key} ${AddOfferField.name}`]
        if (choice) return AddOfferField.paidOption.includes(choice)
        return isRosProduct(String(values[key] || '').toLowerCase())
    }).some(Boolean)
}

export const shouldAddChooseOfferButton = (data) => {
    // now we need to check if any value of mailerProductNames Object has "ROS" in it
    // Fixed typo in 'toLowerCase' and added proper parentheses for function call
    return GetAddOfferValueFromGetValues(data)
}

export const hasAddProductInCampaign = (data) => {
    const mailerProductNames = filterMaileTypesFromGetValues(data) // Assuming this function exists and works as intended
    // now we need to check if any value of mailerProductNames Object has "ROS" in it
    // Fixed typo in 'toLowerCase' and added proper parentheses for function call
    return Object.values(mailerProductNames).some((name) =>
        isRosProduct(String(name).toLowerCase()),
    )
}

/**
 *
 * param data getValues()
 */
export const noOfRealPennedProductsInCampaign = (data) => {
    const mailerProductNames = filterMaileTypesFromGetValues(data)
    // Fixed typo in 'toLowerCase' and added proper parentheses for function call
    return Object.values(mailerProductNames).filter((name) =>
        isRealPennedProduct({ name }),
    ).length
}

/**
 * Calculates the average price based on product data and an optional quantity for tiered pricing.
 *
 * @param {Object} mainJsonData - The main JSON data containing product names.
 * @param {Array} additionalProductData - An array of products with pricing and other details.
 * @param {number} quantity - The quantity used to determine tiered pricing (optional).
 * @returns {string} - The calculated average price as a string, formatted to two decimal places.
 */
function calculateAveragePrice(mainJsonData, additionalProductData, quantity) {
    // const touches = convertStep(mainJsonData.Touches)

    const filterProductData = filterMaileTypesFromGetValues(mainJsonData)

    const mailerKeys = Object.keys(filterProductData)

    // console.log('filterProductData', filterProductData)

    const prices = mailerKeys
        .map((mailerKey) => {
            const productName = filterProductData[mailerKey]

            if (!productName) return

            // console.log('productName', productName, additionalProductData)

            const filteredProduct = additionalProductData.find(
                (product) => productName == product.name,
            )

            // console.log('additionalProductData', additionalProductData)

            const valueToProcess = Object.fromEntries(
                Object.entries(mainJsonData).filter(([key]) =>
                    key.startsWith(mailerKey),
                ),
            )

            const transformProductData = (data, mailerKey) => {
                // Adding a space after the mailerKey for proper splitting and matching
                const keyPrefix = `${mailerKey} `
                return Object.fromEntries(
                    Object.entries(data)
                        .filter(
                            ([key]) => key.startsWith(keyPrefix), // Using startsWith for direct comparison
                        )
                        .map(
                            ([key, value]) => [key.split(keyPrefix)[1], value], // Splitting the key with the complete keyPrefix including space
                        ),
                )
            }

            const valuesWithMailerKeys = {
                [postageFieldName]: mainJsonData[postageFieldName],
                ...transformProductData(valueToProcess, mailerKey),
            }

            // console.log('valuesWithMailerKeys', valuesWithMailerKeys)

            const selectedVariation = selectVariationFromProduct(
                filteredProduct,
                valuesWithMailerKeys,
            )

            // console.log(
            //     'selectedVariation',
            //     selectedVariation,
            //     valuesWithMailerKeys,
            // )

            // Determine which pricing to use (variation specific or default product).
            const pricingInfo =
                selectedVariation?.item || selectedVariation.product

            // Check if a quantity is specified and if there are any tiered pricing rules.
            if (
                !quantity ||
                Object.keys(pricingInfo.tiered_pricing_fixed_rules).length === 0
            ) {
                // If no quantity is specified or no tiered pricing rules exist, use the base price.
                return parseFloat(pricingInfo.price)
            } else {
                // Sort the tier thresholds to apply the correct pricing based on the specified quantity.
                const tiers = Object.keys(
                    pricingInfo.tiered_pricing_fixed_rules,
                )
                    .map(Number)
                    .sort((a, b) => a - b)
                let applicablePrice = parseFloat(pricingInfo.price) // Start with the base price.

                // console.log('pricingInfo', pricingInfo)

                // Iterate over sorted tiers to find the most appropriate price based on the quantity.
                for (let tier of tiers) {
                    // console.log(
                    //     'loop of calculateCYOPricingBasedOnProducts',
                    //     tier,
                    //     quantity,
                    // )
                    if (quantity >= tier) {
                        applicablePrice = parseFloat(
                            pricingInfo.tiered_pricing_fixed_rules[tier],
                        )
                    } else {
                        break // Exit loop once the appropriate tier is found or exceeded.
                    }
                }

                if (!applicablePrice) return parseFloat(pricingInfo.price)

                return applicablePrice // Return the tiered or base price as determined by the quantity.
            }
        })
        .filter((price) => price)

    // Calculate the average price from the filtered and mapped prices.
    const averagePrice =
        prices.reduce((acc, price) => acc + price, 0) / prices.length
    return averagePrice.toFixed(3) // Format the average price to three decimal places and return.
}

export const selectVariationFromProduct = (product, valueToProcess) => {
    const variations = product.variations

    // console.log('selectVariationFromProduct product', product)
    // console.log('selectVariationFromProduct variations', variations)
    // console.log('selectVariationFromProduct', valueToProcess)

    const variationsArray = variations.map((item) => {
        let { id, attributes } = item
        let optionValues = {}
        attributes.forEach((item) => {
            const { name, option } = item
            optionValues[name] = option
        })
        return {
            id,
            optionValues,
            item,
        }
    })

    // console.log('variationsArray', variationsArray)

    // we need figureout pricing based on products based
    const variation = variationsArray.find(({ optionValues }) => {
        return isMatch(valueToProcess, optionValues)
    })

    // console.log('variation', variation)

    if (variation) return variation

    return product
}

// This should be removed. 15th April 2024
// New CYO Pricing
export const generateMultiTouchValuesForVariationToSelect = (values) => {
    /** To set Multi Touch variations, we need to see how many letters, postcards and flyers and then make data based on that. */
    const touches = convertStep(values.Touches)
    // No we need to get the number of letters, postcards and flyers
    // lets get all mailer types
    let multiTouchSelectionValues = {
        Letters: 0,
        Flyers: 0,
        Postcards: 0,
    }
    const isLetter = (value) => value.includes('Letter')
    const isFlyer = (value) => value.includes('Flyer')
    const isPostcard = (value) => value.includes('Postcard')

    for (let index = 1; index <= touches; index++) {
        const typeName = `${MultiTouchField.name} ${index}`
        const hasValue =
            values[typeName] !== undefined && values[typeName] !== null

        if (hasValue) {
            if (isLetter(values[typeName])) {
                multiTouchSelectionValues.Letters += 1
            } else if (isFlyer(values[typeName])) {
                multiTouchSelectionValues.Flyers += 1
            } else if (isPostcard(values[typeName])) {
                multiTouchSelectionValues.Postcards += 1
            }
        }
    }
    // we need to convert to string in order to match
    for (const key of Object.keys(multiTouchSelectionValues)) {
        multiTouchSelectionValues[key] = String(multiTouchSelectionValues[key])
    }

    return { ...values, ...multiTouchSelectionValues }
}

export const processAddToCart = async (cartItem) => {
    cartItem = { ...cartItem, _key: nanoid() } // we add unique key to each item, which later used for store api

    // // We will add on to Cart
    const addOns = await getAddOnToAddToCart(cartItem, {
        throwOnUnresolvedVariation: true,
    })

    await addToServerCart(cartItem, addOns)

    return [cartItem, addOns]
}

const prepareForServerCart = (data) => {
    const exclude = [
        'option_name',
        'option_value',
        'name',
        'product',
        'quantity',
        'variation',
    ]

    let dataArray = []
    for (const key of keys(data)) {
        if (exclude.includes(key)) continue

        const value = isObject(data[key])
            ? JSON.stringify(data[key])
            : data[key]
        dataArray.push({
            name: key,
            value,
        })
    }
    return dataArray
}

const getOrderId = async () => {
    // we need to do this because we need to save files with orderId, so we checkout order.
    const { order_id } = await CartAPI.getForceCheckout()
    return order_id
}

export const addToServerCart = async (cartItem, addOns) => {
    /**
     * before we can convert files and upload them, we need to have order id
     * which we don't have unless we add one to cart
     * So we can create add a product to it, get checkout, delete that product and get order id
     * and then do the whole cart for that order, in the process as well, if we have logged in customer, we will add customer there.
     */

    let item = prepareItemForWoo(cartItem)

    // server included
    const items = await prepareItemDataItems(cartItem)
    item.item_data = prepareForServerCart(items)

    // Add impersonation metadata if user is impersonated
    if (_isImpersonated()) {
        const adminEmail = _getImpersonatedByEmail()
        if (adminEmail) {
            item.item_data.push({
                name: '_added_by_impersonated_user_email',
                value: adminEmail,
            })
        }
    }

    addOns = addOns.map((addOn) => {
        const item = prepareItemForWoo(addOn)
        item.item_data = prepareForServerCart(addOn)

        // Add impersonation metadata to addOns if user is impersonated
        if (_isImpersonated()) {
            const adminEmail = _getImpersonatedByEmail()
            if (adminEmail) {
                item.item_data.push({
                    name: '_added_by_impersonated_user_email',
                    value: adminEmail,
                })
            }
        }

        return item
    })

    const allItems = [item, ...addOns]

    let responseData

    const { data } = await nextAPI.post('/cart', {
        item: allItems,
    })
    responseData = data

    log('addToServerCart', 'responseData', data)

    fbTrackAddToCart(allItems)

    // log('addToServerCart', 'addOns', addOns)
    // const response = await Promise.all(addOns.map((item) => nextAPI.post('/cart', {item})))
    // log('addToServerCart', 'response', response)

    return responseData
}

export const prepareItemForWoo = (item) => {
    const { _key } = item

    let quantity =
        item?.product && item?.product.slug && isCampaignProduct(item.product)
            ? Number(item.quantity)
            : Number(item.quantity)

    // getCampaingTouches(item) * item.quantity

    const productId = item.productId
    item = item.variation || item.product || item
    const id = item.id ?? item.product_id ?? productId

    quantity = quantity ? Number(quantity) : 1

    return {
        id,
        _key,
        quantity,
        variation: item.optionValues ? item.optionValues : {},
    }
}

export const prepareItemsForWoo = (items) => {
    const prepared = items.map((item) => {
        return prepareItemForWoo(item)
    })
    return prepared
}

export const prepareItemDataItems = async (item) => {
    // server included

    let preparedItem = {}

    let order_id
    if (has(item, leadField.name)) {
        order_id = await getOrderId()
    }

    let cleanItem = omit(item, [
        'toc',
        'price',
        'variation',
        'product',
        'productCategories',
        'variationId',
        'productId',
        'product',
        'name',
        'option_value',
        'option_name',
        // 'parent_key',
        // '_key',
    ])

    cleanItem[_BATCH_PRICE_KEY] = String(item.price) // this is how we will calculate the batch price in order in backend
    // cleanItem[_DISCOUNTED_TOTAL_KEY] = String(item[_DISCOUNTED_TOTAL_KEY]) // discounted total, this will be used in backend too.

    const undeliverableFieldName = undelivarblesField.name
    const shouldIncludeInvalids = cleanItem[undeliverableFieldName] || false

    log('cleanItem', cleanItem)

    //**
    // We need to add originalFiles and Mapped Files in the end of the meta
    // since this is object there is no way to control order, hence we will
    // create a new array and then add it in the end
    //*/
    let csvFiles = {}

    for (let [key, value] of Object.entries(cleanItem)) {
        if (typeof value === 'string') {
            preparedItem[key] = value
        } else if (Array.isArray(value)) {
            let first = value[0]
            let convertedValue = value
            if (typeof first?.data === 'object') {
                // if this is object its gotta be json files, so these are bascially csvs
                convertedValue = await convertSmartySteetValidJsonToFiles(
                    value,
                    shouldIncludeInvalids,
                    { id: order_id },
                )
                convertedValue = await FileAPI.uploadFiles(convertedValue, {
                    id: order_id,
                })
                // so in store key name is files, but we want to show MappedFiles in order, so we need to change key here as well
                if (isCsvFilesField(key)) {
                    key = MappedFieldName // this special case for mappedfiles only
                }
            } else if (typeof first?.data === 'string') {
                // this base64, these are user uploaded files,
                convertedValue = await convertBase64ToFiles(value)
                convertedValue = await FileAPI.uploadFiles(convertedValue, {
                    id: order_id,
                })
            } else if (typeof first?.url === 'string') {
                // duplicated orders can restore files as already-uploaded remote refs
                convertedValue = value.map((file) => ({
                    name:
                        file.name ||
                        String(file.url).split('/').pop() ||
                        'Uploaded file',
                    url: file.url,
                }))
            }

            // we can these in the end of the meta
            if (isLeadFiles(key))
                csvFiles[key] = convertToArrayToLines(convertedValue)
            else preparedItem[key] = convertToArrayToLines(convertedValue) // in all cases this convert to line and add to key
        }
    }

    return { ...preparedItem, ...csvFiles }
}

export const canNotDelete = (item) => item.name !== 'Undeliverable Mail Fee'

export const getLinePriceItem = ({ meta_data, price }) => {
    const getBatchPrice = meta_data.find(
        (item) => item.key === _BATCH_PRICE_KEY,
    )
    // const isCampaingProduct = name.includes('Campaign')
    if (getBatchPrice) return formatPrice(getBatchPrice.value)
    return formatPrice(price)
}

export const realPennedAdditionalFields = {
    type: 'toggle',
    name: 'Mail For Customer',
    label: 'Mail letters for me - No shipping fee',
    description: 'If true, You will not be charged shipping fee.',
    value: false,
    required: false,
    stringToMatch: 'shipping',
    valueCheck: 'yes',
    metaToDelete: [professionalShippingField, shippingField],
    shouldConvertBoolean: true,
}

export const realPennedEnvelopeFieldDefinition = {
    type: 'select',
    name: 'Real Penned Envelope',
    label: 'Real Penned Envelope',
    options: ['No', 'Yes (+$0.10)'],
    required: false,
    value: 'No',
    defaultValue: 'No',
}

export const shouldNotAddFields = [realPennedAdditionalFields]

const getAdditionalFieldsForProduct = (product, getValues) => {
    const values = getValues()
    let additionalFields = []

    if (isCYOProduct(product)) {
        return additionalFields
    }

    const unSealdValue = 'Unsealed + $65'
    const isStandardClass = values[postageFieldName] === standardClassPostage

    // const hasUnSealedValue = Boolean(
    //     checkMetaValueInCYOValues(
    //         values,
    //         envelopeOptionFieldName,
    //         unSealdValue,
    //     ),
    // )

    if (isRealPennedProduct(product)) {
        const shouldAdd =
            values[envelopeOptionFieldName] !== unSealdValue && !isStandardClass
        if (shouldAdd) {
            additionalFields.push(realPennedAdditionalFields)
        }
    }

    return additionalFields
}

export const handleShouldDeleteMetasAndValueChange = (cleanData) => {
    log('handleShouldDeleteMetasAndValueChange', cleanData)
    shouldNotAddFields.forEach((field) => {
        if (has(cleanData, field.name)) {
            if (field.shouldConvertBoolean) {
                cleanData[field.name] = cleanData?.[field.name] ? 'yes' : 'no'
            }
            if (cleanData[field.name] == field.valueCheck) {
                field.metaToDelete.forEach(({ name }) => {
                    delete cleanData[name]
                })
            }
        }
    })
}

function convertUrlsArrayToATagString(urlsArray) {
    return urlsArray
        .filter((url) => !isNull(url))
        .map((url) => `<a href="${url}">${url}</a>`)
        .join('<br/>')
}

const handleLogoField = (data, fieldName) => {
    if (!Array.isArray(data[fieldName])) return

    const urlsArray = data[fieldName] || []
    if (urlsArray.length === 0) {
        delete data[fieldName]
    } else {
        data[fieldName] = convertUrlsArrayToATagString(urlsArray)
    }
}

export const preprareWithLogoArrayString = (
    data,
    isMultiTouchProduct = false,
) => {
    if (isMultiTouchProduct) {
        let i = 1
        while (data[`Mailer Type ${i} ${logoField.name}`] !== undefined) {
            handleLogoField(data, `Mailer Type ${i} ${logoField.name}`)
            i++
        }
    } else {
        handleLogoField(data, logoField.name)
    }

    return data
}

export const isNotCustomizableFn = ({ item, values, product, mailerKey }) => {
    const isACampaignProduct = product && isCampaignProduct(product)

    const selectedTemplate =
        values?.[makeFieldMultiTouch(selectTemplateField.name, mailerKey)]
    const selectedTemplateIsDesignMyFile =
        selectedTemplate == designMyFileFieldName

    // this was added later on when doing CYO, so we need to make sure that we don't break anything
    if (selectedTemplateIsDesignMyFile && item.isAttribute) {
        return false
    }

    const customizeMailPieceFieldValue =
        values?.[makeFieldMultiTouch(customizeMailPieceField.name, mailerKey)]

    const mandatoryCustomizationBasedOnProductType =
        isALetterProduct(product) && selectedTemplateIsDesignMyFile

    // For CYO/Campaign products: respect the explicit toggle value
    // Only default to true if the toggle hasn't been set yet (undefined)
    const enableCustomization =
        customizeMailPieceFieldValue === true
            ? true
            : customizeMailPieceFieldValue === false
            ? false
            : isACampaignProduct
            ? true
            : false

    if (!item.isAttribute) {
        return false
    }

    if (enableCustomization || mandatoryCustomizationBasedOnProductType) {
        return false
    }

    return true
}
export const AttributesFieldName = 'attributes'

export const makeFieldMultiTouch = (name, key) => {
    if (!key || name.includes(key) || name.includes('Mailer')) return name
    return `${key} ${name}`
}

export const isNullFieldType = ({
    item,
    product,
    values,
    attributes,
    mailerKey,
}) => {
    // Hide Mailing Date field if Real Pen Envelope is set to a "Yes" option
    if (item.name === 'Mailing Date' && values) {
        const realPenEnvelopeValue = values[realPennedEnvelopeFieldName]
        if (realPenEnvelopeValue?.startsWith('Yes')) {
            return true // Hide the field
        }
    }

    if (isServiceProduct(product)) return false

    const isNotCustomizable = isNotCustomizableFn({
        item,
        values,
        product,
        mailerKey,
    })
    // const {isThisMultiTouchProduct} = props

    mailerKey = item.isAttribute ? item.mailerKey : mailerKey

    const selectedTemplate =
        values?.[makeFieldMultiTouch(selectTemplateField.name, mailerKey)]
    // log('selectedTemplate isNullFieldType', selectedTemplate, mailerKey, makeFieldMultiTouch(selectTemplateField.name, mailerKey))
    const templateHasNotSet =
        isEmpty(selectedTemplate) ||
        isUndefined(selectedTemplate) ||
        isNull(selectedTemplate)
    const selectedTemplateIsDesignMyFile =
        selectedTemplate == designMyFileFieldName

    const selectedTemplateIsPreviouslyDesignedFile =
        selectedTemplate == selectPreviouslyDesignedFileFieldName

    const excludedFields = (field) => {
        const conditions = [
            isPostageField(field),
            isHandwritingField(field),
            isEnevelopOptionField(field),
            field.name.includes(logoField.name),
            !field.name.includes(selectTemplateField.name),
        ]

        // Return true if any condition is true
        return conditions.some((condition) => condition)
    }

    const attributesFieldNames = attributes
        ? attributes
              .filter((field) => {
                  return !excludedFields(field)
              })
              .map((field) => field.name)
        : []

    // console.log('attributes', attributes, attributesFieldNames)

    const customizeMailPieceFieldName = makeFieldMultiTouch(
        customizeMailPieceField.name,
        mailerKey,
    )
    const logoFieldName = makeFieldMultiTouch(logoField.name, mailerKey)

    const removeFieldsConditionalTemplates = [
        customizeMailPieceFieldName,
        ...attributesFieldNames,
    ]

    const shouldRemoveFieldBasedonTemplates = values
        ? isEmpty(values[selectTemplateField.name]) ||
          selectedTemplateIsPreviouslyDesignedFile
        : false

    // log('isNullFieldType -2', item, isThisMultiTouchProduct, !selectedTemplate, item.name, makeFieldMultiTouch(selectTemplateField.name, item.mailerKey), values)
    // if(isThisMultiTouchProduct && !selectedTemplate && item.isAttribute) {
    //     return null
    // }

    if (templateHasNotSet && customizeMailPieceFieldName === item.name) {
        log('isNullFieldType -1', item.name)
        return true
    }

    if (
        templateHasNotSet &&
        item.isAddOnField &&
        item.name !== AddOfferField.name &&
        item.name !== pagesAndPrintingField.name
    ) {
        log('isNullFieldType 0', item.name)
        return true
    }

    if (isNull(selectedTemplate) && logoFieldName === item.name) {
        log('isNullFieldType 1', item.name)
        return true
    }

    if (
        selectedTemplateIsDesignMyFile &&
        removeFieldsConditionalTemplates.includes(item.name) &&
        item.isAttribute &&
        isNotALetterProduct(product)
    ) {
        log('isNullFieldType 2', item.name, item)
        return true
    }

    if (
        isALetterProduct(product) &&
        selectedTemplateIsDesignMyFile &&
        item.name == customizeMailPieceFieldName
    ) {
        log('isNullFieldType 3', item.name)
        return true
    }

    if (
        selectedTemplateIsDesignMyFile &&
        removeFieldsConditionalTemplates.includes(item.name) &&
        isALetterProduct(product)
    ) {
        log('isNullFieldType 4', item.name)
        return false
    }

    if (
        selectedTemplateIsDesignMyFile &&
        removeFieldsConditionalTemplates.includes(item.name) &&
        isNotALetterProduct(product) &&
        item.isAttribute
    ) {
        log('isNullFieldType 5', item.name)
        return true
    }

    if (product && isCampaignProduct(product)) {
        log('isNullFieldType 6', item.name)
        return false
    }

    if (
        (isPostageField(item) ||
            isHandwritingField(item) ||
            isEnevelopOptionField(item)) &&
        item.isAttribute
    ) {
        log('isNullFieldType 7', item.name)
        return true
    }

    if (
        selectedTemplateIsDesignMyFile &&
        item.name === customizeMailPieceFieldName
    ) {
        log('isNullFieldType 7-2', item.name)
        return true
    }

    if (
        selectedTemplateIsDesignMyFile &&
        item.isAttribute &&
        isNotCustomizable
    ) {
        log('isNullFieldType 8', item.name, item)
        return true
    }

    if (
        shouldNotIncludeField(item, product) ||
        !shouldIncludeField(item, product)
    ) {
        // log('shouldIncludeField')
        log('isNullFieldType 9', item.name)
        return true
    }

    const defaultCustomizationTemplateValue =
        values[defaultCustomizationTemplateFieldName]

    // log('isNullFieldType not 10', item.name, defaultCustomizationTemplateValue, isNotCustomizable, 'isValidating', isValidating)

    log('isNullFieldType not 10', item, isNotCustomizable, selectedTemplate)

    // if(item.isAttribute && !defaultCustomizationTemplateValue[item.name] && isNotCustomizable){
    //     return null
    // }

    if (
        (isEmpty(defaultCustomizationTemplateValue) ||
            !defaultCustomizationTemplateValue[item.name]) &&
        isNotCustomizable
    ) {
        log(
            'isNullFieldType 10',
            item.name,
            isEmpty(defaultCustomizationTemplateValue),
            isNotCustomizable,
        )
        return true
    }

    if (shouldRemoveFieldBasedonTemplates) {
        if (
            removeFieldsConditionalTemplates.includes(item.name) &&
            item.isAttribute
        ) {
            log('isNullFieldType 11', item.name)
            return true
        }
    }

    if (
        selectedTemplateIsPreviouslyDesignedFile &&
        (item.isAttribute ||
            logoFieldName === item.name ||
            item.name === customizeMailPieceFieldName)
    ) {
        log('isNullFieldType 12', item.name)
        return true
    }

    if (
        selectedTemplateIsPreviouslyDesignedFile &&
        item.name === editMessageFieldName
    ) {
        log('isNullFieldType 13', item.name)
        return true
    }

    return false
}

export const mayBeConvertTemplateURLToATag = (dataObject) => {
    if (!dataObject) return dataObject

    Object.keys(dataObject).forEach((key) => {
        if (
            key.endsWith('Template') &&
            dataObject[key] &&
            dataObject[key].url &&
            dataObject[key].name
        ) {
            dataObject[
                key
            ] = `<a href='${dataObject[key].url}'>${dataObject[key].name}</a>`
        }
    })

    return dataObject
}

export function convertToSlug(name) {
    return name
        .toLowerCase() // convert the string to lower case
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/[^-\w]+/g, '') // remove all non-word characters
        .replace(/-+/g, '-') // replace multiple hyphens with a single hyphen
        .replace(/^-+/, '') // trim hyphens from the start of the text
        .replace(/-+$/, '') // trim hyphens from the end of the text
}

export const mailerKeyName = 'mailerKey'
export const mailerProductName = 'mailerProduct'

export const OLM_RMS_PRODUCT_NAME = 'OLM Returned Mail Scanner'

export const checkMetaValueInCYOValues = (
    values = {},
    keyToFind,
    valueToCheck,
) => {
    const foundKeys = Object.keys(values).filter((key) =>
        key.includes(keyToFind),
    )
    // console.log('checkMetaValueInCYOValues', foundKeys)
    if (foundKeys.length > 0) {
        const isTrue = foundKeys.some((key) => values[key] == valueToCheck)
        // console.log('checkMetaValueInCYOValues isTrue', isTrue)
        return isTrue
    }

    return false
}

export const extractMailerNumber = (text) => {
    const match = String(text || '').match(/#?Mailer (\d+)/)
    return match ? match[1] : null
}
